<div class="footer-left">
  <div class="information-block">
    <div class="information-title title"><span
        class="information-title title">{{ 'customerService.TITLE' | translate }}</span></div>
    <div>
      <span class="information-text">{{ 'phoneService.TITLE' | translate }}: 0800.555.666</span><br />
      <span class="information-text">{{ 'doubts.TITLE' | translate }}: email@itau-unibanco.com.br</span>
    </div>
  </div>
  <div class="information-block">
    <div class="information-title"><span class="title">{{ 'general.TITLE' | translate }}</span></div>
    <div>
      <a href="#" class="information-text"><span
          class="information-text">{{ 'tutorials.TITLE' | translate }}</span></a><br />
      <a href="#" class="information-text"><span
          class="information-text">{{ 'viewAllFeatures.TITLE' | translate }}</span></a>
    </div>
  </div>
</div>
<mat-divider class="hidden-mobile"></mat-divider>
<div class="footer-accordion">
  <mat-accordion [displayMode]="'flat'" [multi]="true">
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
        <mat-panel-title>
          <span class="information-title">{{ 'customerService.TITLE' | translate }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <span class="information-text">{{ 'phoneService.TITLE' | translate }}: 0800.555.666</span><br />
      <span class="information-text">{{ 'doubts.TITLE' | translate }}: email@itau-unibanco.com.br</span>
    </mat-expansion-panel>
    <mat-divider></mat-divider>
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
        <mat-panel-title>
          <span class="information-title">{{ 'general.TITLE' | translate }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <a href="#" class="information-text"><span
          class="information-text">{{ 'tutorials.TITLE' | translate }}</span></a><br />
      <a href="#" class="information-text"><span
          class="information-text">{{ 'viewAllFeatures.TITLE' | translate }}</span></a>
    </mat-expansion-panel>
    <mat-divider></mat-divider>
  </mat-accordion>
</div>